<div class="bg-success">
    <div class="container bg-success">
        <div class="timeline-wrapper">
            <div class="">
                <div class="">
                    <div class="timeline-flow clearfix">
                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/Wakeup Bell.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">
                                        <h2>Waking up</h2>
                                        <h2>5.00 AM </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/yoga.png">
                                    </div>
                                    <div class="col-lg text-left mt-1">
                                        <h2>Power Yoga - 5.15-6.00 AM</h2>
                                        <h2>Disease Specific Yoga - 6.00- 6.45 AM</h2>
                                        <h2>General Yoga - 6.15-7.00 AM</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">

                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/Herbal Tea.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">
                                        <h2>Herbal tea</h2>
                                        <h2>7.00-7.30 AM</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/Massage.png">
                                    </div>
                                    <div class="col-lg text-center mt-1">
                                        <h2>Massage and Hydrotherapy Treatments</h2>
                                        <h2>7.30-10.30 AM</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;">
                                        <img class="img-fluid" src="assets/img/Juice.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">
                                        <h2>Juices </h2>
                                        <h2>8.00-9.00 AM</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/Lunch.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">
                                        <h2>Naturopathy Lunch(Annapoorna)</h2>
                                        <h2>10.30-12.00 PM</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;">
                                        <img class="img-fluid" src="assets/img/Rest.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">
                                        <h2>Rest </h2>
                                        <h2>12-2.15 PM</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/yoga.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">
                                        <h2>Disease specific Yoga</h2>
                                        <h2>2.15-2.45 PM</h2>
                                    </div>
                                </div>
                            </div>
                        </div> -->


                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">

                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/Herbal Tea.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">
                                        <h2>Herbal tea </h2>
                                        <h2>3.00-3.15 PM</h2>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;">
                                        <img class="img-fluid" src="assets/img/Treatment.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">

                                        <h2>Hydrotherapy treatments</h2>
                                        <h2>3.00-5.00 PM</h2>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/Juice.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">
                                        <h2>Juices</h2>
                                        <h2>4.00-4.30 PM</h2>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>

                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/Letcture.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">
                                        <h2>Health Discourses</h2>
                                        <h2>4.30-5.30 PM</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/Dinner.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">
                                        <h2>Naturopathy Dinner</h2>
                                        <h2>5.30-6.30 PM</h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/Reading.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">
                                        <h2>Rest and leisure time</h2>
                                        <h2>6.30-7.15 PM</h2>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/Prayer.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">
                                        <h2>Prayer(Yogasadhana Hall)</h2>
                                        <h2>7.15-7.45 PM</h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/Meditation.png">
                                    </div>
                                    <div class="col-lg text-center mt-1">
                                        <h2>Meditation/Trataka(Yogasadhana Hall)</h2>
                                        <h2>7.45-8.30 PM</h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/Walking.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">
                                        <h2>Recreation and Leisure</h2>
                                        <h2>8.30-9.30 PM</h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="timeline-block p-2">
                            <div class="timeline-badge bg-white">
                                <span class="icon"><i class="fa fa-clock-o fa-2x text-dark"
                                        aria-hidden="true"></i></span>
                            </div>
                            <div class="timeline-card">
                                <div class="row container-fluid d-flex justify-content-center">
                                    <div class="col-lg-4 text-left" style="padding-left: 0;"><img class="img-fluid"
                                            src="assets/img/Rest.png">
                                    </div>
                                    <div class="col-lg text-center mt-4">
                                        <h2>Bed Time</h2>
                                        <h2>9.30 PM</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>